import React from 'react';

const Spinner = () => {
  return (
    <div 
      id="spinner" 
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white"
      style={{ zIndex: 9999 }}
    >
      <div className="text-center">
        <div className="position-relative mb-4">
          <div 
            className="spinner-border text-primary opacity-25" 
            style={{ width: '4rem', height: '4rem' }} 
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <div 
            className="spinner-border text-primary position-absolute top-0 start-0" 
            style={{ width: '4rem', height: '4rem', animationDirection: 'reverse' }} 
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        
        <div className="mb-3">
          <h5 className="fw-bold text-primary mb-2">
            <i className="fas fa-video me-2"></i>
            MastiShorts
          </h5>
          <p className="text-muted mb-0">Loading your experience...</p>
        </div>
        
        <div className="progress" style={{ width: '200px', height: '4px' }}>
          <div 
            className="progress-bar bg-primary" 
            role="progressbar" 
            style={{ 
              width: '100%',
              animation: 'progressAnimation 2s ease-in-out infinite'
            }}
          >
          </div>
        </div>
      </div>
      
      <style jsx>{`
        @keyframes progressAnimation {
          0% { width: 0%; }
          50% { width: 100%; }
          100% { width: 0%; }
        }
      `}</style>
    </div>
  );
};

export default Spinner;
